import React, { useEffect, useRef } from 'react';
import { CheckSquare, Bell, MessageSquare } from 'lucide-react';

const AddItemMenu = ({ onSelect, onClose }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    const itemTypes = [
        {
            type: 'task',
            label: 'Task',
            description: 'Action items, quizzes, trainings',
            icon: CheckSquare,
            color: 'text-blue-600',
            bg: 'bg-blue-50',
            hoverBg: 'hover:bg-blue-100'
        },
        {
            type: 'notice',
            label: 'Notice',
            description: 'Announcements and information',
            icon: Bell,
            color: 'text-yellow-600',
            bg: 'bg-yellow-50',
            hoverBg: 'hover:bg-yellow-100'
        },
        {
            type: 'survey',
            label: 'Survey',
            description: 'Feedback and questionnaires',
            icon: MessageSquare,
            color: 'text-purple-600',
            bg: 'bg-purple-50',
            hoverBg: 'hover:bg-purple-100'
        }
    ];

    return (
        <div
            ref={menuRef}
            className="absolute bottom-full left-0 right-0 mb-2 bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden z-20"
        >
            <div className="p-2">
                <p className="text-xs text-gray-500 px-2 py-1 font-medium">Select item type</p>
                {itemTypes.map((item) => (
                    <button
                        key={item.type}
                        onClick={() => !item.disabled && onSelect(item.type)}
                        disabled={item.disabled}
                        className={`
                            w-full flex items-center gap-3 p-2 rounded-lg transition-colors text-left
                            ${item.disabled
                                ? 'opacity-50 cursor-not-allowed'
                                : item.hoverBg
                            }
                        `}
                    >
                        <div className={`p-2 rounded-lg ${item.bg}`}>
                            <item.icon className={`w-4 h-4 ${item.color}`} />
                        </div>
                        <div>
                            <p className="text-sm font-medium text-gray-800">{item.label}</p>
                            <p className="text-xs text-gray-500">{item.description}</p>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AddItemMenu;
